<div class="suite-result-sec">
    <div>
        <h5 *ngIf="entityType === ENTITY_MASTERSUITE">Testsuites</h5>
        <h5 *ngIf="entityType === ENTITY_TESTSUITE">Testcases</h5>
        <!-- List -->
        <div class="lists">
            <div title="{{entity?.name}}"
                class="list text-truncate {{entity?.executionStatus||entity?.execution.executionStatus}}"
                [ngClass]="{'active' : entity?.noSqlId === activeIndex || entity?.id === activeIndex }"
                *ngFor="let entity of entities; index as tabIndex"
                (click)="readEntityExecutionDetails(entity?.noSqlId || entity?.id, tabIndex)">
                {{tabIndex + 1}}. {{entity?.name || entity?.testCaseName}}
            </div>
            <div class="mt-3">Total : {{entities?.length}}</div>
        </div>

        <!-- Details -->
        <div class="details">
            <div class="row">
                <div class="col-12">
                    <h5 *ngIf="entityExecutionResults !== undefined && entityExecutionResults !== null ">
                        <a *ngIf="entityType === ENTITY_TESTSUITE"
                            [routerLink]="['/testcase', entityExecutionResults.sqlId]" target="_blank">
                            <i class="fas fa-link" ngbTooltip="Go to Testcase" placement="right"></i>
                        </a>
                        <a *ngIf="entityType === ENTITY_MASTERSUITE"
                            [routerLink]="['/testsuite', entityExecutionResults.sqlId]" target="_blank">
                            <i class="fas fa-link" ngbTooltip="Go to Testsuite" placement="right"></i>
                        </a>
                        {{entityExecutionResults.name}}
                        <a (click)="showMobileTCVideo(entityExecutionResults)"
                         *ngIf="(testSuiteInfo.mobileTestSuite || testSuiteInfo.desktopTestSuite) && entityExecutionResults.execution.videoRecorded">
                            <i class="fas fa-video" ngbTooltip="Show Video" placement="left"></i>
                        </a>
                    </h5>
                    <hr>
                </div>
            </div>
            <div class="row">
                <div class="col-3">
                    <span class="font-bold">Status : </span>
                    <small>{{entityExecutionResults?.execution?.executionStatus}}</small>
                </div>
                <div class="col-3">
                    <span class="font-bold">Start Time : </span>
                    <small>{{entityExecutionResults?.execution?.startTime | localDate}}</small>
                </div>
                <div class="col-3">
                    <span class="font-bold">End Time : </span>
                    <small>{{entityExecutionResults?.execution?.endTime | localDate}}</small>
                </div>
                <div class="col-3">
                    <span class="font-bold">Time Taken : </span>
                    <small>{{entityExecutionResults?.execution?.totalExecutionTimeInSec | secondsToHms}}</small>
                </div>
                <div class="col-4">
                    <span class="font-bold">Execution id : </span>
                    <small>{{entityExecutionResults?.execution?.noSqlId}}</small>
                </div>
            </div>
            <div class="row" *ngIf="entityType === ENTITY_TESTSUITE && projectConfiguration !== 'PLAYWRIGHT'">
                <div class="col-2">
                    <span class="font-bold">Retry :</span>
                    <small>{{entityExecutionResults?.reTry}}</small>
                </div>
                <div class="col-3">
                    <span class="font-bold">Retry attempt :</span>
                    <small>{{entityExecutionResults?.reTryAttempt}}</small>
                </div>
                <div class="col-2">
                    <span class="font-bold">Delay :</span>
                    <small>{{entityExecutionResults?.delay}}</small>
                </div>
            </div>
            <br>

            <!-- Error section for skipped -->
            <ngb-alert [type]="'danger'" *ngIf="entityExecutionResults?.execution?.exceptionOccured && !closeErrorAlert"
                (close)="closeErrorAlert = true">
                <strong>Error !</strong>
                {{entityExecutionResults?.execution?.exceptionMessage}}
            </ngb-alert>
            <ngb-alert [type]="'warning'" (close)="warningFlag=false" dismissible="true"
                *ngIf="entityExecutionResults?.execution?.warningOccured && !entityExecutionResults?.execution?.exceptionOccured && entityExecutionResults?.execution?.executionStatus === 'PENDING' && warningFlag && parallelRun">
                <strong>Warning! </strong>
                {{entityExecutionResults?.execution?.warningMessage }}
            </ngb-alert>

            <div class="data-group relay-margin-top-10">
                <div *ngIf="entityType !== ENTITY_TESTSUITE">
                    <div class="list">
                        <div class="header">
                            <div class="row">
                                <div class="col-md-9">
                                    <div class="row">
                                        <div class="col-md-2">
                                            <span class="badge"
                                                [ngClass]="{ 'badge-danger' : (entityExecutions?.execution.executionStatus === 'FAILED') , 'label-relay-error' :
                                            (entityExecutions?.execution.executionStatus === 'RELAY_ERROR') , 'badge-success' :(entityExecutions?.execution.executionStatus === 'PASSED') ,
                                            'badge-warning' : (entityExecutions?.execution.executionStatus === 'SKIPPED'), 'badge-primary' : (entityExecutions?.execution.executionStatus === 'IN_PROGRESS') }">
                                                {{entityExecutions?.execution?.executionStatus}}</span>
                                        </div>
                                        <div class="col-md-2 text-success">
                                            <span class="">Pass :</span>
                                            {{entityExecutions?.passCount}}
                                        </div>
                                        <div class="col-md-2 text-danger">
                                            <span class="">Fail :</span>
                                            {{entityExecutions?.failedCount}}
                                        </div>
                                        <div class="col-md-2">
                                            <span class="text-warning">Skip :</span>
                                            {{entityExecutions?.skippedCount}}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3 text-right">
                                    <i class="fas"
                                        [ngClass]="(entityExecutions !== undefined && entityExecutions.isNavCollapsed) ? 'fa-angle-down' : 'fa-angle-up' "
                                        (click)="entityExecutions.isNavCollapsed = !entityExecutions?.isNavCollapsed"></i>
                                </div>
                            </div>
                        </div>
                        <div class="body-content" [ngbCollapse]="entityExecutions?.isNavCollapsed ">
                            <div>
                                <app-results-endpoint *ngIf="ENTITY_TESTSUITE === entityType"
                                    [tcExecData]="entityExecutions" [testCaseDetail]="entities[entityIndex]"
                                    [tCaseIndex]="entityIndex"
                                    [projectConfiguration]="projectConfiguration"></app-results-endpoint>
                            </div>
                            <app-suite-result
                                *ngIf="ENTITY_MASTERSUITE === entityType && entityExecutions?.testSuiteExecutions"
                                [entityType]="'TESTSUITE'" [entityExecDetails]="childEntityExec"
                                [parallelRun]="parallelRun" [entityExecResults]="childEntityResult"
                                (readEntityExecution)="readChildEntityExecutionDetails($event)" [projectConfiguration]="projectConfiguration"></app-suite-result>
                        </div>
                    </div>
                </div>

                <div *ngIf="entityType === ENTITY_TESTSUITE">

                    <div *ngIf="selectedExecutionData">
                        <div class="row">
                            <div class="col-md-7 d-flex">
                                <div style="margin: 5px; width: 30%;" ngbTooltip="Type to filter test data sequence">TestData Sequence : </div>
                                <button class="btn btn-primary btn-sm" [disabled]="!showPrevious" style="width: 10%; margin-right: 10px;" type="button" ngbTooltip="Previous" (click)="previousTestData()"><i class="fas fa-backward"></i></button>
                                <ng-select class="required custom-style" style="width: 50%;" [items]="testDataSequenceList" bindLabel="testDataSequenceNumber" bindValue="id" [searchable]="true" (change)="getExecutionDetails($event)" [(ngModel)]="selectedExecutionDataId">
                                  <ng-template ng-option-tmp let-item="item">
                                    <div title="{{ item.testDataSequenceNumber }}" class="text-truncate {{getStatusColor(item.executionStatus)}}">{{
                                                  item.testDataSequenceNumber }} </div>
                                  </ng-template>
                                </ng-select>
                                <button class="btn btn-primary btn-sm" [disabled]="!showNext"  style="width: 10%; margin-left: 10px;" ngbTooltip="Next" type="button" (click)="nextTestData()"><i class="fas fa-forward"></i></button>
                              </div>
                            <div class="col-md-5 d-flex" *ngIf="(selectedExecutionData?.mobileTestCase || selectedExecutionData?.desktopTestCase) && entityExecutionResults?.reTryAttempt > 0">
                                <div style="margin: 5px;">Retry Attempt : </div>
                                <button class="btn btn-primary btn-sm" [disabled]="selectedRetryAttempt === 0" style="width: 10%; margin-right: 10px;" type="button" ngbTooltip="Previous" (click)="selectedRetryAttempt = selectedRetryAttempt - 1; getExecutionDetails(selectedExecutionData)"><i class="fas fa-backward"></i></button>
                                <ng-select class="required custom-style" style="width: 30%;" [items]="retryArray" bindLabel="name" bindValue="id" [searchable]="true" (change)="getExecutionDetails(selectedExecutionData)"  [(ngModel)]="selectedRetryAttempt"></ng-select>
                                <button class="btn btn-primary btn-sm" [disabled]="selectedRetryAttempt === entityExecutionResults?.reTryAttempt"  style="width: 10%; margin-left: 10px;" ngbTooltip="Next" type="button" (click)="selectedRetryAttempt = selectedRetryAttempt + 1; getExecutionDetails(selectedExecutionData)"> <i class="fas fa-forward"></i> </button>
                            </div>
                        </div>
                        <div class="accordion mt-2" *ngIf="showGraphSection(testSuiteInfo, entityExecutionResults, selectedExecutionData)">
                            <h6 class="clickable mt-2 mb-2" (click)="showGraph = !showGraph">
                              <span>
                                <i class="fas fa-caret-right clickable collapse-icon p-1" *ngIf="!showGraph"></i>
                                <i class="fas fa-caret-down clickable collapse-icon p-1" *ngIf="showGraph"></i>Performance Graph</span>
                            </h6>
                            <div *ngIf="showGraph">
                              <app-mobile-performance-graph class="mt-2 mb-2" [mostRecentExecuted]="selectedExecutionData" [parentIndex]="selectedExecutionDetailsIndex" [type]="'TESTSUITE'"></app-mobile-performance-graph>
                            </div>
                        </div>
                        <div class="mt-2" style="background-color: white; display: block;"
                            *ngIf="selectedExecutionDetails">
                            <br>
                            <div style="display: flex;">
                                <div class="col-md-2">
                                    <label class="font-weight-bold">Status :</label>
                                    <span class="pl-1"
                                        [ngClass]="{'PASSED' : selectedExecutionDetails.executionStatus === 'PASSED' ,'FAILED' : selectedExecutionDetails.executionStatus === 'FAILED' }">{{selectedExecutionDetails.executionStatus}}</span>
                                </div>
                                <div class="col-md-1">
                                    <label class="font-weight-bold">Pass :</label>
                                    {{selectedExecutionDetails.passedCount}}
                                </div>
                                <div class="col-md-1">
                                    <label class="font-weight-bold">Fail :</label>
                                    {{selectedExecutionDetails.failedCount}}
                                </div>
                                <div class="col-md-1">
                                    <label class="font-weight-bold">Skip :</label>
                                    {{selectedExecutionDetails.skippedCount}}
                                </div>
                                <div class="col-md-2">
                                    <label class="font-weight-bold">Valid skip :</label>
                                    {{selectedExecutionDetails.validSkipCount}}
                                </div>
                                <div class="col-md-3">
                                    <label class="font-weight-bold">Time taken :</label>
                                    {{selectedExecutionDetails.totalTime | secondsToHms}}
                                </div>
                            </div>
                            <div style="margin: 10px 0px;">
                                <app-results-endpoint [selectedRetryAttempt]="selectedRetryAttempt" [testCaseDetail]="entities[entityIndex]"
                                    [tcExecData]="selectedExecutionDetails" [tCaseIndex]="selectedExecutionDetailsIndex"
                                    [projectConfiguration]="projectConfiguration"></app-results-endpoint>
                                <!-- <app-results-endpoint *ngIf="ENTITY_TESTSUITE === entityType" [tcExecData]="execution" [testCaseDetail]="entities[entityIndex]" [tCaseIndex]="parentIndex"></app-results-endpoint> -->
                            </div>
                            <app-suite-result *ngIf="ENTITY_MASTERSUITE === entityType" [entityType]="'TESTSUITE'"
                                [parallelRun]="parallelRun" [entityExecDetails]="childEntityExec"
                                [entityExecResults]="childEntityResult" [projectConfiguration]="projectConfiguration"></app-suite-result>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Pagination -->
        <div class="row pagination-sec" *ngIf="showPagination">
            <div class="col-1" *ngIf="collectionSize > 0">
                <select class="form-control form-control-sm" (change)="onSizeChange(pageSize)" [(ngModel)]="pageSize">
                    <option>15</option>
                    <option>25</option>
                    <option>50</option>
                    <option>100</option>
                </select>
            </div>
            <div class="col-5" *ngIf="collectionSize > 0">
                <ngb-pagination [collectionSize]="collectionSize" [maxSize]="5" [pageSize]="pageSize" [(page)]="page"
                    [boundaryLinks]="true" [rotate]="true" (pageChange)="onPageChange($event)"></ngb-pagination>
            </div>
        </div>
    </div>
</div>